import { useEffect, useState } from "react";
import ButtonIconH from "./ButtonIconH";
import "../css/PopupMessage.css";
import "../css/PopupNIFTypes.css";
import CheckBox from "./CheckBox";
import DataTable from "react-data-table-component";
import { selectedOptic, userData } from "../js/utils";
import { post } from "../js/post";
import { patientNIFColumns } from "../js/tableColumns";

export default function PopupNIFTypes(props) {
  const [options, setOptions] = useState([]);
  const [selectedNIF, setSelectedNIF] = useState({});

  const updatedColumns = patientNIFColumns.map((col) => {
    if (col.name === "Seleccionado") {
      return {
        ...col,
        cell: (row) => (
          <CheckBox
            active={row.active}
            onClick={() => {
              setOptions((prev) =>
                prev.map((e) => ({
                  ...e,
                  active: e.idNif === row.idNif,
                })),
              );
              setSelectedNIF({ ...row, active: true });
            }}
          ></CheckBox>
        ),
      };
    }

    return col;
  });

  const getPatientDocumentTypes = async () => {
    const response = await post("ObtenerTiposDocumentoPaciente.php", {
      token: userData.token,
      optica: selectedOptic.id,
    });
    const list = response.map((e) => ({ ...e, active: false }));
    const selected = list.find((e) => e.idNif === props.idNif);

    if (selected) {
      selected.active = true;
      setSelectedNIF(selected);
    }
    setOptions(list);
  };

  useEffect(() => {
    getPatientDocumentTypes();
  }, []);

  return (
    <div className="popup-container" style={{ zIndex: 20 }}>
      <div className="ap-container popup-screen" style={{ zIndex: 20 }}>
        <div className="popup-screen-header">
          <span className="popup-screen-header-title">
            Selección de tipo de documento
          </span>
          <button
            className="popup-action-icon close-icon"
            onClick={() => {
              props.onClick();
            }}
          >
            <img src="/images/close-white.svg" loading="lazy" alt="Icon"></img>
          </button>
        </div>
        <div
          className="store-products-table delivery-note-table"
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            gap: 10,
            padding: 10,
          }}
        >
          <div
            className="container-panel"
            style={{
              display: "flex",
              flexDirection: "column",
              gap: 20,
              width: 600,
            }}
          >
            <DataTable
              columns={updatedColumns}
              data={options}
              className="custom-datatable datatable-lists"
              noDataComponent="No hay listas disponibles."
              onRowClicked={(row) => {
                setOptions((prev) =>
                  prev.map((e) => ({
                    ...e,
                    active: e.idNif === row.idNif,
                  })),
                );
                setSelectedNIF({ ...row, active: true });
              }}
            />
            <div className="popup-buttons">
              <ButtonIconH
                text="Aceptar"
                onClick={() => {
                  props.onClick();
                  props.onAccept(selectedNIF);
                }}
              ></ButtonIconH>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
